import { ref, readonly } from 'vue'

const isVisible = ref(false)
const message = ref('')

export function useToast() {
  const showToast = (msg: string) => {
    message.value = msg
    isVisible.value = true
    setTimeout(() => {
      isVisible.value = false
    }, 3000)
  }

  return {
    isVisible: readonly(isVisible),
    message: readonly(message),
    showToast
  }
}
